//email validation format
export const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

//Constants in reseller agent dashboard
export const optimumPlan = [
  {
    field: "optimum_plans",
    name: "Optimum plans",
    dropdown: true,
    required: true,
  },
  {
    field: "add_ons",
    name: "Add ons",
    dropdown: true,
    required: false,
  },
  {
    field: "toggle",
    name: "Keep Existing Number",
    type: "toggle",
    required: false,
  },
  {
    field: "radio_buttons",
    name: "Pick a device option",
    type: "radio",
    options: [
      { value: "byod", label: "BYOD" },
      { value: "add_phone", label: "Add a Phone" },
    ],
    required: true,
  },
  {
    field: "mobile_devices",
    name: "Mobile device",
    dropdown: true,
    required: true,
  },
  {
    field: "finance_options_id",
    name: "Financing options",
    dropdown: true,
    required: true,
  },
  {
    field: "device_imei",
    name: "Device IMEI",
    dropdown: false,
    required: true,
  },
];

export const customerInfo = [
  {
    field: "business_name",
    name: "Business name",
    dropdown: false,
    required: true,
    type: "text",
    limit: 50,
  },
  {
    field: "customer_name",
    name: "Customer name",
    dropdown: false,
    required: true,
    type: "text",
    limit: 50,
  },
  {
    field: "phone_number",
    name: "Contact phone number",
    dropdown: false,
    required: true,
    type: "text",
    limit: 16,
  },
  {
    field: "email",
    name: "Customer email address",
    dropdown: false,
    required: true,
    type: "email",
    limit: 100,
  },
  {
    field: "tax_id",
    name: "Tax ID",
    dropdown: false,
    required: true,
    type: "text",
    limit: 9,
  },
  {
    field: "account_number",
    name: "Account number (if applicable)",
    dropdown: false,
    required: false,
    type: "number",
    limit: 17,
  },
  {
    field: "zipcode",
    name: "Zip code",
    dropdown: false,
    required: true,
    type: "text",
    limit: 12,
  },
  {
    field: "location",
    name: "State",
    dropdown: false,
    required: true,
    type: "dropdown",
  },
  {
    field: "billing_address",
    name: "Billing address",
    dropdown: false,
    required: true,
    type: "textarea",
    limit: 250,
  },
];

export const sections = [
  {
    name: "Configure Optimum Plan",
    fieldSet: optimumPlan,
    style: "optimum-plan",
  },
  { name: "Customer info", fieldSet: customerInfo, style: "customer-info" },
];

export const optimumPlanSection = {
  name: "Configure Optimum Plan",
  fieldSet: optimumPlan,
  style: "optimum-plan",
};

export const customerInfoSection = {
  name: "Customer Information",
  fieldSet: customerInfo,
  style: "customer-info",
};

//dummy Data
export const bills = [
  {
    number: "(332) 210-0309",
    body: [
      { name: "Galaxy S24 Ultra", monthly: "$36", today: "" },
      { name: "Activation Fee", monthly: "", today: "$20" },
      {
        name: "Coverage: Optimum Mobile Device Protection",
        monthly: "$15",
        today: "",
      },
    ],
    monthly: "$30",
    today: "",
  },
  {
    number: "(332) 210-0287",
    body: [{ name: "Activation Fee", monthly: "", today: "$20" }],
    monthly: "",
    today: "$20",
  },
];

export const totalBill = {
  body: [
    { name: "Full price", monthly: "$111.11", today: "$40.00" },
    { name: "Taxes", monthly: "$6.06", today: "$116.53" },
  ],
  monthly: "$117.7",
  today: "$156.63",
};
